import { DEVICE_ROLES } from '@/features/core/container';
import { MetricResolutionAggregator, MetricResolutionTimeSource, SpotRole } from '@/types/iot-portal';
import { option } from '@/util/container';
import { component } from '../component';
import lg from './section-meter-water-meter-hot-lg.svg';
import md from './section-meter-water-meter-hot-md.svg';
import sm from './section-meter-water-meter-hot-sm.svg';

export default option(DEVICE_ROLES, async () => ({
  name: SpotRole.SECTION_METER_WATER_METER_HOT,
  label: 'Zwischenzähler_Warmwasserzähler',
  shortLabel: 'Zs_Warmw',
  icons: { sm, md, lg },
  component: component('section-meter-water-meter-hot/SectionMeterHotWaterMeterDevicePanel.vue'),
  props: { volumeColor: 'RED' },
  aggregationWidget: {
    enabled: true,
    component: component('section-meter-water-meter-hot/SectionMeterHotWaterMeterAggregationWidget.vue'),
    props: { digitColor: 'RED' },
  },
  defaultMetricNames: ['currentVolume'],
  importantMetricNames: ['currentVolume', 'currentFlow'],
  aggregationMetricNames: [
    {
      name: 'currentVolume',
      aggregators: [MetricResolutionAggregator.SUM],
      timeSource: MetricResolutionTimeSource.START,
    },
  ],
  consumption: true,
}));
